import Box from '@mui/material/Box';
import CssBaseline from '@mui/material/CssBaseline';
import AppBar from '@mui/material/AppBar';
import Toolbar from '@mui/material/Toolbar';
import Typography from '@mui/material/Typography';
import { Button } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import UserMenu from '../components/UserMenu';
import ConnectionStatus from '../components/ConnectionStatus';
import { openPrimaryDownload } from '../lib/downloads';
import { useAuth } from '../context/AuthContext';
import LanguageSwitcherButton from '../components/LanguageSwitcherButton';

const AppBarDashboard = () => {
  const navigate = useNavigate();
  const { legacyWebAccess } = useAuth();
  const { t } = useTranslation('common');

  return (
    <Box sx={{ display: 'flex' }}>
      <CssBaseline />
      <AppBar color="default" elevation={1} position="fixed">
        <Toolbar>
          <Typography onClick={() => { navigate(legacyWebAccess ? '/dashboard' : '/minha-conta'); }} variant="span" component="div" sx={{ cursor: 'pointer' }} color="primary">
            <b>GAME VISION PRO</b>
          </Typography>

          <Box sx={{ ml: 2, flexGrow: 1, display: 'flex', alignItems: 'center' }} />

          <LanguageSwitcherButton sx={{ mr: 2 }} />

          {!window.electron && (
            <Button sx={{ mr: 2 }} onClick={() => { openPrimaryDownload(); }} variant="outlined" size="small">
              {t('actions.freeDownload')}
            </Button>
          )}

          <ConnectionStatus sx={{ mr: 2 }} />
          <UserMenu />
        </Toolbar>
      </AppBar>
    </Box>
  );
};

export default AppBarDashboard;
